<div class="card shadow-sm rounded-4 sp-um-header p-4">
    <div class="sp-um-header-top d-flex flex-column flex-md-row align-items-stretch align-items-md-start justify-content-between gap-3">
        <div>
            <p class="aic-page-eyebrow text-uppercase fw-bold mb-1 text-warning">Administration</p>
            <h1 class="fs-4 fw-bold m-0 text-dark">User management</h1>
            <p class="text-sm m-0 text-secondary lh-base">Add users, update their roles, and manage account access.</p>
        </div>

        <button type="button" class="btn d-inline-flex align-items-center justify-content-center gap-2 text-sm btn-primary text-nowrap text-decoration-none text-dark" @click="$emit('open-add-user')">
            <i class="bi bi-person-plus"></i> Add user
        </button>
    </div>

    <div class="sp-stat-row d-grid mt-4">
        <div class="gap-2 p-3 rounded-3 d-flex flex-column flex-md-row align-items-start align-items-md-center border bg-body-tertiary">
            <span class="sp-stat-icon d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 text-warning-emphasis bg-warning-subtle"><i class="bi bi-people"></i></span>
            <div>
                <div class="fs-4 fw-bold text-dark lh-1">{{ users_count }}</div>
                <div class="text-xs fw-medium text-secondary">Total users</div>
            </div>
        </div>
        <div class="gap-2 p-3 rounded-3 d-flex flex-column flex-md-row align-items-start align-items-md-center border bg-body-tertiary">
            <span class="sp-stat-icon text-success bg-success-subtle d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3"><i class="bi bi-person-check"></i></span>
            <div>
                <div class="fs-4 fw-bold text-dark lh-1">{{ active_users_count }}</div>
                <div class="text-xs fw-medium text-secondary">Active</div>
            </div>
        </div>
        <div class="gap-2 p-3 rounded-3 d-flex flex-column flex-md-row align-items-start align-items-md-center border bg-body-tertiary">
            <span class="sp-stat-icon text-secondary bg-body-tertiary d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3"><i class="bi bi-person-slash"></i></span>
            <div>
                <div class="fs-4 fw-bold text-dark lh-1">{{ inactive_users_count }}</div>
                <div class="text-xs fw-medium text-secondary">Inactive</div>
            </div>
        </div>
    </div>
</div>
